import request from "@/utils/request";
import Vue from "vue";
// const server = "/cloudhealth-server-portal"
const server = "/business";

//患者列表
export function getPatients(query) {
  return request({
    url: server + "/healthinfo/getPatients",
    method: "post",
    data: query,
  });
}

//患者标签
export function getPatientLabels(query) {
  return request({
    url: server + "/healthinfo/getPatientLabels",
    method: "get",
    params: query,
  });
}

//患者详情列表
export function getPatientDetail(id) {
  return request({
    url: server + "/healthinfo/getPatientDetail",
    method: "get",
    params: { id: id },
  });
}

//根据风险情况获取患者列表
export function getPatientByRisk(query) {
  return request({
    url: server + "/healthinfo/getPatientByAssessmentResult",
    method: "post",
    data: query,
  });
}

//根据达标率查询
export function getPatientByReachRate(query) {
  return request({
    url: server + "/healthinfo/getPatientByAssessmentResult",
    method: "post",
    params: query,
  });
}

//根据ASCVD评估类型查询
//根据达标率查询
export function getPatientByAssessmentResultFilter(groupName) {
  return request({
    url: server + "/healthinfo/getPatientByAssessmentResultFilter",
    method: "post",
    params: { group: groupName },
  });
}

// 获取患者联系人列表
export function getPatientContacts(query) {
  return request({
    url: server + "/healthinfo/getPatientContacts",
    method: "post",
    params: query,
  });
}

// 获取患者证件列表
export function getPatientCards(query) {
  return request({
    url: server + "/healthinfo/getPatientCards",
    method: "post",
    params: query,
  });
}

// 医生列表
export function getDoctors(query) {
  return request({
    url: server + "/healthinfo/getDoctors",
    method: "post",
    params: query,
  });
}

//获取患者总数和按年龄分段的患者数量
export function getPatientSummary() {
  return request({
    url: server + "/healthinfo/getPatientSummary",
    method: "get",
    params: {},
  });
}

//指标风险人数
export function getRiskDistributionNum(type) {
  return request({
    url: server + "/es/statistics/model",
    method: "post",
    params: { assessmentType: type },
  });
}

//危险因素达标率
export function getReachRate() {
  return request({
    url: server + "/healthinfo/dashboard/getReachRate",
    method: "get",
    params: {},
  });
}

//危险因素患病率
export function getChronicRate() {
  return request({
    url: server + "/healthinfo/statis/getChronicRateStatis",
    method: "get",
    params: {},
  });
}

//获取最近患者警报
export function getRiskWarnRecords(query) {
  return request({
    url: server + "/healthinfo/dashboard/getRiskWarnRecords",
    method: "post",
    data: query,
  });
}

//修改患者警报状态
export function updateRiksExecuted(query) {
  return request({
    url: server + "/healthinfo/updateRiksExecuted",
    method: "post",
    data: query,
  });
}

//获取指定患者的最新的所有病种的评估
export function getLatestAssessment(patientIdsStr) {
  return request({
    url: server + "/healthinfo/getLatestAssessmentsOfAll",
    method: "get",
    params: { patientIds: patientIdsStr },
  });
}

// 获取健康档案列表
export function getSearchList(query) {
  return request({
    url: "/business/ehr/search",
    method: "post",
    data: query,
  });
}

// 根据筛选条件获取健康档案列表
export function getSearchListByLabel(query) {
  return request({
    url: "/business/ehr/searchByLabel",
    method: "post",
    data: query,
  });
}

//纳入联系 纳入管理
export function addIntegrateManage(param) {
  return request({
    url: "/business/ehr/addIntegrateManage",
    method: "post",
    data: param,
  });
}

// 获取健康档案列表
export function getSolrSearchList(query) {
  return request({
    url: "/business/ehr/solrSearch",
    method: "post",
    data: query,
  });
}

// 获取家庭档案列表
export function getFamilySearchList(query) {
  return request({
    url: "/business/family/search",
    method: "post",
    data: query,
  });
}

// 获取健康档案列表
export function getAllSearchList(query) {
  return request({
    url: "/business/ehr/searchAll",
    method: "post",
    data: query,
  });
}

// 根据筛选条件获取健康档案列表跳转
export function turnToPageListByLabel(query) {
  return request({
    url:
      "/business/ehr/searchByLabel?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 健康档案列表跳转
export function turnToPageList(query) {
  return request({
    url:
      "/business/ehr/search?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 家庭档案列表跳转
export function turnToFamilyPageList(query) {
  return request({
    url:
      "/business/family/search?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 健康档案列表跳转
export function turnToSolrPageList(query) {
  return request({
    url:
      "/business/ehr/solrSearch?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 添加健康档案信息
export function addPatientList(query) {
  return request({
    url: "/business/ehr/addEhr",
    method: "post",
    data: query,
  });
}

// 删除病人健康档案信息
export function delPatientList(query) {
  return request({
    url: "/business/ehr/delete?id=" + query.id,
    method: "post",
    data: query,
  });
}

// 更新健康档案信息
export function updatePatientList(query) {
  return request({
    url: "/business/ehr/updateEhr",
    method: "post",
    data: query,
  });
}

// 获取家庭联系人列表
export function getContactList(params) {
  return request({
    url: "/business/family/list",
    method: "post",
    data: params,
  });
}

// 更新家庭联系人列表
export function turnToContactList(query) {
  return request({
    url:
      "/business/family/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 添加家庭联系人
export function addContactList(query) {
  return request({
    url: "/business/family/add",
    method: "post",
    data: query,
  });
}

// 更新家庭联系人
export function updateContactList(query) {
  return request({
    url: "/business/family/update",
    method: "post",
    data: query,
  });
}
// 删除家庭联系人
export function delContactList(query) {
  return request({
    url: "/business/family/delete?id=" + query.id,
    method: "post",
    data: query,
  });
}

// 获取机构列表
export function getManagerHospitalList(query) {
  return request({
    url: "/business/sysDept/list?page=1&pageSize=10000",
    method: "post",
    data: query,
  });
}

// 获取省市区乡镇列表
export function getAreaList(query) {
  return request({
    url: "/business/areaCode/list?page=1&pageSize=100",
    method: "post",
    data: query,
  });
}

// 获取高血糖数据列表
export function getDiabetList(query) {
  return request({
    url: "/business/disease/dashboardByDisease?disease=糖尿病",
    method: "post",
    data: query,
  });
}

// 获取高血糖比例
export function getDiabetRate(query) {
  return request({
    url: "/business/disease/measureListByDay?disease=糖尿病",
    method: "post",
    data: query,
  });
}

// 获取高血压数据列表
export function getBloodList(query) {
  return request({
    url: "/business/disease/dashboardByDisease?disease=高血压",
    method: "post",
    data: query,
  });
}

// 获取高血压比例
export function getBloodRate(query) {
  return request({
    url: "/business/disease/measureListByDay?disease=高血压",
    method: "post",
    data: query,
  });
}

// 获取高血脂数据列表
export function getAscvdList(query) {
  return request({
    url: "/business/disease/dashboardByDisease?disease=高血脂",
    method: "post",
    data: query,
  });
}

// 获取高血脂比例
export function getAscvdRate(query) {
  return request({
    url: "/business/disease/measureListByDay?disease=高血脂",
    method: "post",
    data: query,
  });
}

// 获取首页数据
export function getHomepageData(query) {
  return request({
    url: "business/dashboard/homepage",
    method: "post",
    data: query,
  });
}

// 新建随访管理
export function commitFollowUp(query) {
  return request({
    url: "/business/patientFollowupRecord/commit",
    method: "post",
    data: query,
  });
}

// 随访列表按照时间查询
export function getListByTime(query) {
  return request({
    url: "/business/patientFollowupRecord/listByTime",
    method: "post",
    data: query,
  });
}

// 随访列表按照时间查询
export function turnToListByTime(query) {
  return request({
    url:
      "/business/patientFollowupRecord/listByTime?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 随访列表详情按照id查询详情
export function getPatientFollowupRecord(params) {
  return request({
    url: "/business/patientFollowupRecord/getByPk",
    method: "get",
    params: params,
  });
}

// 随访列表详情按照id删除
export function delPatientFollowupRecord(query) {
  return request({
    url: "/business/patientFollowupRecord/delete?id=" + query.id,
    method: "post",
    data: query,
  });
}

//获取出院随访列表
export function getPatientVisitList(query, page, pageSize) {
  return request({
    url: "/business/patientVisit/search?page=" + page + "&pageSize=" + pageSize,
    method: "post",
    data: query,
  });
}

// 获取空腹血糖值，并根据空腹血糖值得到下次随访时间
// export function getFollowupValue(params) {
//   return request({
//     url: '/business/patientFollowupRecord/getFollowupValueByTime?startTime=2020-01-01&endTime=2099-12-31',
//     method: 'get',
//     params: params
//   })
// }

export function getFollowupValue(params) {
  return request({
    url: "/business/patientHealthParam/listHealthParamsByIdcard",
    method: "post",
    data: params,
  });
}

// 获取协诊机构列表
export function getListMyDept(query) {
  return request({
    url: "/business/patientCoDiagnosis/listMyDept",
    method: "post",
    data: query,
  });
}

// 患者列表一键转诊
export function applyCoDiag(query) {
  return request({
    url: "/business/patientCoDiagnosis/applyCoDiag",
    method: "post",
    data: query,
  });
}

// 我发起的协诊列表
export function getListMyApply(query) {
  return request({
    url: "/business/patientCoDiagnosis/listMyApply",
    method: "post",
    data: query,
  });
}

// 我发起的协诊列表更新
export function turnToMyApply(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listMyApply?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 我收到的协诊列表
export function getListMyCodiag(query) {
  return request({
    url: "/business/patientCoDiagnosis/listMyCodiag",
    method: "post",
    data: query,
  });
}

// 我处理的协诊列表
export function getlistMyCodiagDone(query) {
  return request({
    url: "/business/patientCoDiagnosis/listMyCodiagDone",
    method: "post",
    data: query,
  });
}

// 我处理的协诊列表更新
export function turnToMyCodiagDone(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listMyCodiagDone?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 协诊列表
export function getlistCodiagReport(query) {
  return request({
    url: "/business/patientCoDiagnosis/codiagReport",
    method: "post",
    data: query,
  });
}

//协诊列表导出
export function codiagReportToExcel(query) {
  return request({
    url: "/business/patientCoDiagnosis/codiagReportToExcel",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

// 协诊列表更新
export function turnToCodiagReport(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/codiagReport?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 我收到的协诊列表更新
export function turnToMyCodiag(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listMyCodiag?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 协诊二十四小时过期
export function getlistMyCodiagExpired(query) {
  return request({
    url: "/business/patientCoDiagnosis/listMyCodiagExpired",
    method: "post",
    data: query,
  });
}

// 协诊二十四小时过期列表更新
export function turnTolistMyCodiagExpired(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listMyCodiagExpired?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 协诊填写处理
export function saveCoDiag(query) {
  return request({
    url: "/business/patientCoDiagnosis/coDiag",
    method: "post",
    data: query,
  });
}

// 通过id查询协诊详情
export function getByIdCoDiag(query) {
  return request({
    url: "/business/patientCoDiagnosis/getById?id=" + query.id,
    method: "post",
    data: query,
  });
}

//协诊V2-我管理的
export function getlistCodiags(query) {
  return request({
    url: "/business/patientCoDiagnosis/listCodiag",
    method: "post",
    data: query,
  });
}

//V2我处理的协诊列表更新
export function turnToMyListCodiag(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listCodiag?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

export function postMyListCodiag(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listCodiag?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 查询血糖列表
export function getBloodSugarList(query) {
  return request({
    url: "/business/iotBloodSugar/list",
    method: "post",
    data: query,
  });
}

// 查询血糖检测人次列表
export function getBloodSugarTestingList(query) {
  return request({
    url: "/business/iotBloodSugar/listPatientCount",
    method: "post",
    data: query,
  });
}

// 我收到的协诊列表更新
export function turnToBloodSugarList(query) {
  return request({
    url:
      "/business/iotBloodSugar/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 健康档案嵌入网页Src
export function getHealthUrl(query) {
  return request({
    url: "/business/ehr/getHealthUrlByIdcard",
    method: "post",
    data: query,
  });
}

// 纳入糖尿病管理
export function updateEhrManage(query) {
  return request({
    url: "/business/ehr/updateEhrManage",
    method: "post",
    data: query,
  });
}

// 获取机构liebiao
export function getUserInfos(query) {
  return request({
    url: "/business/sysUser/getUserInfos",
    method: "post",
    data: query,
  });
}

// 获取管理率
export function getQualityReport(query) {
  return request({
    url: "/business/report/qualityReport",
    method: "post",
    data: query,
  });
}

export function getByIdPatientDetail(params) {
  return request({
    url: "/business/ehr/getByPk?id=" + params.id,
    method: "post",
    data: params,
  });
}

// 血糖监测记录一键协诊
export function getCoDiagDirect(params) {
  return request({
    url: "/business/patientCoDiagnosis/coDiag",
    method: "post",
    data: params,
  });
}

// 机构科室查询
export function getDeptList(params) {
  return request({
    url: "/business/dept/list?page=1&pageSize=100",
    method: "post",
    data: params,
  });
}

// 查询条件机构查询
export function getListMyDepts(params) {
  return request({
    url: "/business/sysUser/listMyDepts",
    method: "post",
    data: params,
  });
}

// 新建档案机构查询
export function getlistEhrDepts(params) {
  return request({
    url: "/business/sysUser/listEhrDepts",
    method: "post",
    data: params,
  });
}

// 检查检验项目查询
export function getlistClinicItem(params) {
  return request({
    url: "/business/patientCoDiagnosis/listClinicItem?page=1&pageSize=2000",
    method: "post",
    data: params,
  });
}

export function getMedicineList(params) {
  return request({
    url: "/business/hisPharmItem/list?page=1&pageSize=2000",
    method: "post",
    data: params,
  });
}

// 根据机构科室查询协诊人医师列表
export function getlistMyDeptDoctorList(params) {
  return request({
    url: "business/patientCoDiagnosis/listMyDeptDoctor",
    method: "post",
    data: params,
  });
}

// 血压监测列表
export function getBloodPressureList(params) {
  return request({
    url: "/business/iotBloodPressure/list",
    method: "post",
    data: params,
  });
}

// 血压监测列表
export function turnToBloodPressureList(query) {
  return request({
    url:
      "/business/iotBloodPressure/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 血压监测列表
export function getBloodPressureCount(query) {
  return request({
    url: "/business/iotBloodPressure/listPatientCount",
    method: "post",
    data: query,
  });
}

// 血压监测列表
export function turnToBloodPressureCount(query) {
  return request({
    url:
      "/business/iotBloodPressure/listPatientCount?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// ************获取一体化档案列表/旧版方法名
export function getEhrListByDisease(query) {
  return request({
    url:
      "/business/patientStdmanage/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// *************跳转一体化某患者列表/旧版方法名
export function turnToEhrListByDisease(query) {
  return request({
    url:
      "/business/patientStdmanage/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 获取一体化档案列表
export function getPatientStdmanage(query) {
  return request({
    url:
      "/business/patientStdmanage/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 跳转一体化列表
export function turnToPatientStdmanage(query) {
  return request({
    url:
      "/business/patientStdmanage/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 获取一体化患者详情档案列表
export function getPatientStdmanageTask(query) {
  return request({
    url:
      "/business/patientStdmanageTask/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 跳转一体化某患者详情列表
export function turnToPatientStdmanageTask(query) {
  return request({
    url:
      "/business/patientStdmanageTask/list?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 获取数据统计规范管理列表
export function getPatientStdmanageReportList(query) {
  return request({
    url:
      "/business/patientStdmanage/report?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 获取高血压、糖尿病协诊纪录
export function getListPatientCodiags(query) {
  return request({
    url:
      "/business/patientCoDiagnosis/listPatientCodiags?page=" +
      query.pageNum +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: query,
  });
}

// 协诊处置列表
export function getCodiagForFollowupList(params, page, pageSize) {
  return request({
    url:
      "/business/patientCoDiagnosis/listCodiagForFollowup?page=" +
      page +
      "&pageSize=" +
      pageSize,
    method: "post",
    data: params,
  });
}

//协诊处置列表导出
// export function codiagForFollowupToExcel(query,page,pageSize) {
//   return request({
//     url: '/business/patientCoDiagnosis/listCodiagForFollowupToExcel?page=' + page + '&pageSize=' + pageSize,
//     method: 'post',
//     data: query,
//     responseType: 'blob'
//   })
// }

export function codiagForFollowupToExcel(query) {
  return request({
    url: "/business/patientCoDiagnosis/listCodiagForFollowupToExcel",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

// 协诊处置
export function addFollowupCodiag(params) {
  return request({
    url: "/business/patientCoDiagnosis/followupCodiag",
    method: "post",
    data: params,
  });
}

//列表导出
export function reportToExcel(query) {
  return request({
    url: "/business/report/exportToExcel",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

// 肺结节患者管理导出
export function exportLungPatients(query) {
  return request({
    url: "/business/ehr/exportLungPatients?page=1&pageSize=10000",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

// 肺结节随访管理导出
export function exportLungFollowups(query) {
  return request({
    url: "/business/patientFollowupRecord/exportLungFollowups?page=1&pageSize=10000",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

// 肺结节协诊管理导出
export function exportLungCodiags(query) {
  return request({
    url: "/business/patientCoDiagnosis/exportLungCodiags?page=1&pageSize=10000",
    method: "post",
    data: query,
    responseType: "blob",
  });
}

//字典枚举
export function getSysDicList(params) {
  return request({
    url: "/business/sysDict/list?pageSize=10000",
    method: "post",
    data: params,
  });
}

//健康体检
export function getEhrPhysicalExamList(params) {
  return request({
    url: "/business/ehrPhysicalExam/list",
    method: "post",
    data: params,
  });
}

//糖尿病首页
export function getAppDiabetSpecData(params) {
  return request({
    url: "/business/appDiabetSpecInd/list",
    method: "post",
    data: params,
  });
}

//随访业务数据量
export function getFollowupTips(query) {
  return request({
    url: server + "/doctor/listFollowupTips",
    method: "post",
    data: query,
  });
}

//协诊业务数据量
export function getCodiagTips(query) {
  return request({
    url: server + "/doctor/listCodiagTips",
    method: "post",
    data: query,
  });
}

//血糖检测，血压检测数量
export function getLisMeasureTips(query) {
  return request({
    url: server + "/doctor/listMeasureTips",
    method: "post",
    data: query,
  });
}

//患者档案首页基础指标数据
export function getPatientHealthSummary(params) {
  return request({
    url: "/business/doctor/getPatientHealthSummaryByIdcard",
    method: "post",
    data: params,
  });
}

// 科室列表
export function getDoctorListQlyyDepts(params) {
  return request({
    url: "/business/doctor/listQlyyDepts",
    method: "post",
    data: params,
  });
}

// 科室内医生列表
export function postDoctorListQlyyDoctorsByDept(params) {
  return request({
    url: "/business/doctor/listQlyyDoctorByDept",
    method: "post",
    data: params,
  });
}

// 失访处理：修改复查时间
export function handleLostFollowup(params) {
  return request({
    url: "/business/patientFollowupRecord/handleLostFollowup",
    method: "post",
    data: params,
  });
}

// 满意度回访：设置 refollowFlag 等字段
export function refollowFollowup(query) {
  return request({
    url: "/business/patientFollowupRecord/refollow",
    method: "post",
    data: query,
  });
}
